// libs
import React from 'react'
// components 
// ...
// config & functions 
import config from '../config';
import utils from '../utils';

function Logo({orgInfo, setloadmaincomponent, loadmaincomponent}) {

    const goNext = async (page) => {
		let uc = await utils.updateComponent(loadmaincomponent, {
			name: page,
			status: true
		});
		setloadmaincomponent(uc); // upate component
	}

    return (
        <div className='shadow-sm p-2 bg-body sticky-top border-bottom d-flex justify-content-center align-items-center' style={{height: '60px'}}>
            <button onClick={() => goNext('HomePage')} className="navbar-brand border-0 bg-transparent"> <img src={`${config.assets.images}/${orgInfo.domain}/assets/${orgInfo.logo}`} alt="" style={{maxHeight: '56px'}} /></button>
        </div>
    )
}
export default Logo;
